<template>
  <div class="column is-12-mobile is-12-tablet is-6-desktop is-6-widescreen" v-if="cartGroups.length">
    <form :action="sendUrl" method="POST">
      <input type="hidden" name="_token" v-model="csrfToken" />
      <div class="section">

        <h2 class="title is-size-5 pl-2" :class="'has-text-' + secondaryColor">
          <span class="pl-2">{{ $t('orders.deliveryType') }}</span>
        </h2>
        <div class="box has-background-white-bis p-2 mb-6">
          <div class="p-2">
            <div class="columns is-multiline is-variable is-2 pb-3">
              <div class="column is-6 pb-0" v-for="deliveryType in deliveryTypes">
                <span
                    class="button is-fullwidth"
                    :class="{
                      'is-link': (selectedDeliveryType && (deliveryType.type === selectedDeliveryType.type)),
                    }"
                    @click="updateDeliveryType(deliveryType)"
                >
                  {{ $t('orders.deliveryTypes.' + deliveryType.type) }}
                </span>
              </div>
            </div>
            <p v-if="selectedDeliveryType && selectedDeliveryType.note" class="pb-5">{{ selectedDeliveryType.note }}</p>
            <div class="field" v-if="needsAddress">
              <label class="label">{{ $t('orders.deliveryAddress') }}</label>
              <input name="address" class="input" type="text" v-model="address" :class="{'is-danger': errors.address.length}" />
              <p class="help is-danger" v-for="error in errors.address">{{ error }}</p>
            </div>
          </div>
        </div>

        <h2 class="title is-size-5 pl-2" :class="'has-text-' + secondaryColor">
          <span class="pl-2">{{ $t('orders.paymentType') }}</span>
        </h2>
        <div class="box has-background-white-bis p-2 mb-6">
          <div class="p-2">
            <div class="field" v-if="paymentTypes.length > 0">
              <div class="columns is-multiline is-variable is-2 pb-3">
                <div class="column is-6 pb-0" v-for="paymentType in paymentTypes" :key="paymentType.type">
                  <span
                      class="button is-fullwidth"
                      :class="{
                        'is-link': (selectedPaymentType && (paymentType.type === selectedPaymentType.type)),
                      }"
                      @click="updatePaymentType(paymentType)"
                      v-if="isValidPaymentType(paymentType)"
                  >
                    {{ $t('orders.paymentTypes.' + paymentType.type) }}
                  </span>
                  <button v-else class="button is-fullwidth" :disabled="true">
                    {{ $t('orders.paymentTypes.' + paymentType.type) }}
                  </button>
                </div>
              </div>
              <p v-if="selectedPaymentType && selectedPaymentType.note">{{ selectedPaymentType.note }}</p>
            </div>
          </div>
        </div>

        <h2 class="title is-size-5 pl-2" :class="'has-text-' + secondaryColor">
          <span class="pl-2">{{ $t('orders.customer') }}</span>
        </h2>
        <div class="box has-background-white-bis p-2 mb-6">
          <div class="p-2">
            <div class="columns is-multiline is-variable is-2 pb-3">
              <div class="column is-6 pb-0">
                <div class="field">
                  <label class="label">{{ $t('orders.firstname') }}</label>
                  <input name="firstname" class="input" type="text" v-model="firstname" :class="{'is-danger': errors.firstname.length}" />
                  <p class="help is-danger" v-for="error in errors.firstname">{{ error }}</p>
                </div>
              </div>
              <div class="column is-6 pb-0">
                <div class="field">
                  <label class="label">{{ $t('orders.lastname') }}</label>
                  <input name="lastname" class="input" type="text" v-model="lastname" :class="{'is-danger': errors.lastname.length}" />
                  <p class="help is-danger" v-for="error in errors.lastname">{{ error }}</p>
                </div>
              </div>
              <div class="column is-6 pb-0">
                <div class="field">
                  <label class="label">{{ $t('orders.email') }}</label>
                  <input name="email" class="input" type="text" v-model="email" :class="{'is-danger': errors.email.length}" />
                  <p class="help is-danger" v-for="error in errors.email">{{ error }}</p>
                </div>
              </div>
              <div class="column is-6 pb-0">
                <div class="field">
                  <label class="label">{{ $t('orders.phone') }}</label>
                  <input name="phone" class="input" type="text" v-model="phone" :class="{'is-danger': errors.phone.length}" />
                  <p class="help is-danger" v-for="error in errors.phone">{{ error }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <OrderNote></OrderNote>

        <h2 class="title is-size-5 pl-2" :class="'has-text-' + secondaryColor">
          <span class="pl-2">Shrnutí</span>
        </h2>
        <div class="box has-background-white p-2">
          <div class="p-2">
            <div class="is-flex is-justify-content-space-between has-text-weight-bold">
              <div>Celkem za položky</div>
              <div class="has-text-success">{{ itemPriceFormatted }}</div>
            </div>
            <div class="is-flex is-justify-content-space-between " v-if="totalPackagingPrice > 0">
              <div>Obaly</div>
              <div class="has-text-success">{{ totalPackagingPriceFormatted }}</div>
            </div>
            <div class="is-flex is-justify-content-space-between " v-if="selectedDeliveryType">
              <div>Doprava - {{ selectedDeliveryType.calculated_name }}</div>
              <div class="has-text-success">{{ selectedDeliveryType.price_formatted }}</div>
            </div>
            <div class="is-flex is-justify-content-space-between" v-if="selectedPaymentType">
              <div>Platba - {{ $t('orders.paymentTypes.' + selectedPaymentType.type) }}</div>
              <div class="has-text-success">{{ selectedPaymentType.price_formatted }}</div>
            </div>
            <div class="is-flex is-justify-content-space-between  is-size-4 has-text-weight-bold pt-2">
              <div>Celkem</div>
              <div class="has-text-success">{{ totalPriceFormatted }}</div>
            </div>
            <div class="has-text-centered pt-2">
              <button type="submit" class="button is-danger is-large has-text-weight-bold">
                Odeslat objednávku
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import cartActions from "../../../store/web/cart/action-types";
import cartGetters from "../../../store/web/cart/getter-types";
import OrderNote from "./order/OrderNote.vue";

export default {
  components: {OrderNote},
  props: {
    secondaryColor: String,
    deliveryTypes: Array,
    paymentTypes: Array,
    sendUrl: String,
    csrfToken: String,
  },
  data() {
    return {
      address: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
    };
  },
  mounted() {
    this.address = this.$store.getters['cart/' + cartGetters.GET_ADDRESS];
    this.firstname = this.$store.getters['cart/' + cartGetters.GET_FIRSTNAME];
    this.lastname = this.$store.getters['cart/' + cartGetters.GET_LASTNAME];
    this.email = this.$store.getters['cart/' + cartGetters.GET_EMAIL];
    this.phone = this.$store.getters['cart/' + cartGetters.GET_PHONE];
  },
  computed: {
    cartGroups() {
      return this.$store.getters['cart/' + cartGetters.GET_CART_GROUPS];
    },
    selectedDeliveryType() {
      return this.$store.getters['cart/' + cartGetters.GET_ORDER_DELIVERY_TYPE];
    },
    selectedPaymentType() {
      return this.$store.getters['cart/' + cartGetters.GET_ORDER_PAYMENT_TYPE];
    },
    needsAddress() {
      if (!this.selectedDeliveryType) return false;
      return this.selectedDeliveryType.needs_address;
    },
    validPaymentTypes() {
      return this.$store.getters['cart/' + cartGetters.GET_ORDER_PAYMENT_TYPES];
    },
    isValidPaymentType: () => function (paymentType) {
      return this.validPaymentTypes.find((validPaymentType) => {
        return validPaymentType.type === paymentType.type;
      })
    },
    itemPriceFormatted() {
      return this.$store.getters['cart/' + cartGetters.GET_ITEM_PRICE_FORMATTED];
    },
    totalPriceFormatted() {
      return this.$store.getters['cart/' + cartGetters.GET_TOTAL_PRICE_FORMATTED];
    },
    totalPackagingPrice() {
      return this.$store.getters['cart/' + cartGetters.GET_TOTAL_PACKAGING_PRICE];
    },
    totalPackagingPriceFormatted() {
      return this.$store.getters['cart/' + cartGetters.GET_TOTAL_PACKAGING_PRICE_FORMATTED];
    },
    errors() {
      return this.$store.getters['cart/' + cartGetters.GET_ERRORS];
    }
  },
  methods: {
    updateDeliveryType(deliveryType) {
      this.$store.dispatch('cart/' + cartActions.UPDATE_ORDER_DELIVERY_TYPE, deliveryType.type);
      return false;
    },
    updatePaymentType(paymentType) {
      this.$store.dispatch('cart/' + cartActions.UPDATE_ORDER_PAYMENT_TYPE, paymentType.type);
      return false;
    }
  }
}
</script>

<style>

</style>
